export default function PageReport() {
	return <div>{`PAGEREPORT IS UNDER CONSTRUCTION`}</div>;
}
